import { LOGGED_OUT_CAT_PAGE_SIZE_WITH_NEW_INLINE_BANNER } from "@faire/retailer-shared/categories/createRequests/catNavPageSize";

export const useLoggedOutCategoryPageRequestPageSize = () =>
  LOGGED_OUT_CAT_PAGE_SIZE_WITH_NEW_INLINE_BANNER;
